/* eslint-disable unicorn/no-null */
import {getFlagEmoji} from './flag-emoji'

export const locationsList = [
  {
    id: 1,
    name: 'United Kingdom',
    countryCode: 'GB',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 2,
    name: 'Belgium',
    countryCode: 'BE',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'BE',
      name: 'Belgium',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 3,
    name: 'Czech Republic',
    countryCode: 'CZ',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'CZ',
      name: 'Czech Republic',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 4,
    name: 'Finland',
    countryCode: 'FI',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'FI',
      name: 'Finland',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 5,
    name: 'France',
    countryCode: 'FR',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'FR',
      name: 'France',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 6,
    name: 'Germany',
    countryCode: 'DE',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'DE',
      name: 'Germany',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 7,
    name: 'Hungary',
    countryCode: 'HU',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'HU',
      name: 'Hungary',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 8,
    name: 'Ireland',
    countryCode: 'IE',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'IE',
      name: 'Ireland',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 9,
    name: 'Italy',
    countryCode: 'IT',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'IT',
      name: 'Italy',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 10,
    name: 'Luxembourg',
    countryCode: 'LU',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'LU',
      name: 'Luxembourg',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 11,
    name: 'Netherlands',
    countryCode: 'NL',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'NL',
      name: 'Netherlands',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 12,
    name: 'Poland',
    countryCode: 'PL',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'PL',
      name: 'Poland',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 13,
    name: 'Romania',
    countryCode: 'RO',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'RO',
      name: 'Romania',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 14,
    name: 'Russia',
    countryCode: 'RU',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'RU',
      name: 'Russia',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 15,
    name: 'Slovakia',
    countryCode: 'SK',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'SK',
      name: 'Slovakia',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 16,
    name: 'Spain',
    countryCode: 'ES',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'ES',
      name: 'Spain',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 17,
    name: 'Sweden',
    countryCode: 'SE',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'SE',
      name: 'Sweden',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 18,
    name: 'Switzerland',
    countryCode: 'CH',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'CH',
      name: 'Switzerland',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 19,
    name: 'Turkey',
    countryCode: 'TR',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'TR',
      name: 'Turkey',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 20,
    name: 'Australia',
    countryCode: 'AU',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'AU',
      name: 'Australia',
      supported: true,
      region: {
        id: 8,
        name: 'Oceania',
        supported: true,
        color: 'grey',
      },
    },
  },
  {
    id: 21,
    name: 'New Zealand',
    countryCode: 'NZ',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'NZ',
      name: 'New Zealand',
      supported: true,
      region: {
        id: 8,
        name: 'Oceania',
        supported: true,
        color: 'grey',
      },
    },
  },
  {
    id: 22,
    name: 'China',
    countryCode: 'CN',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'CN',
      name: 'China',
      supported: true,
      region: {
        id: 3,
        name: 'Asia',
        supported: true,
        color: 'cyan',
      },
    },
  },
  {
    id: 23,
    name: 'Hong Kong',
    countryCode: 'HK',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'HK',
      name: 'Hong Kong',
      supported: true,
      region: {
        id: 3,
        name: 'Asia',
        supported: true,
        color: 'cyan',
      },
    },
  },
  {
    id: 24,
    name: 'India',
    countryCode: 'IN',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'IN',
      name: 'India',
      supported: true,
      region: {
        id: 3,
        name: 'Asia',
        supported: true,
        color: 'cyan',
      },
    },
  },
  {
    id: 25,
    name: 'Indonesia',
    countryCode: 'ID',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'ID',
      name: 'Indonesia',
      supported: true,
      region: {
        id: 3,
        name: 'Asia',
        supported: true,
        color: 'cyan',
      },
    },
  },
  {
    id: 26,
    name: 'Japan',
    countryCode: 'JP',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'JP',
      name: 'Japan',
      supported: true,
      region: {
        id: 3,
        name: 'Asia',
        supported: true,
        color: 'cyan',
      },
    },
  },
  {
    id: 27,
    name: 'South Korea',
    countryCode: 'KR',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'KR',
      name: 'South Korea',
      supported: true,
      region: {
        id: 3,
        name: 'Asia',
        supported: true,
        color: 'cyan',
      },
    },
  },
  {
    id: 28,
    name: 'Myanmar [Burma]',
    countryCode: 'MM',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'MM',
      name: 'Myanmar [Burma]',
      supported: true,
      region: {
        id: 3,
        name: 'Asia',
        supported: true,
        color: 'cyan',
      },
    },
  },
  {
    id: 29,
    name: 'Singapore',
    countryCode: 'SG',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'SG',
      name: 'Singapore',
      supported: true,
      region: {
        id: 3,
        name: 'Asia',
        supported: true,
        color: 'cyan',
      },
    },
  },
  {
    id: 30,
    name: 'Thailand',
    countryCode: 'TH',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'TH',
      name: 'Thailand',
      supported: true,
      region: {
        id: 3,
        name: 'Asia',
        supported: true,
        color: 'cyan',
      },
    },
  },
  {
    id: 31,
    name: 'Vietnam',
    countryCode: 'VN',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'VN',
      name: 'Vietnam',
      supported: true,
      region: {
        id: 3,
        name: 'Asia',
        supported: true,
        color: 'cyan',
      },
    },
  },
  {
    id: 32,
    name: 'Qatar',
    countryCode: 'QA',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'QA',
      name: 'Qatar',
      supported: true,
      region: {
        id: 6,
        name: 'Middle East',
        supported: true,
        color: 'red',
      },
    },
  },
  {
    id: 33,
    name: 'Saudi Arabia',
    countryCode: 'SA',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'SA',
      name: 'Saudi Arabia',
      supported: true,
      region: {
        id: 6,
        name: 'Middle East',
        supported: true,
        color: 'red',
      },
    },
  },
  {
    id: 34,
    name: 'United Arab Emirates',
    countryCode: 'AE',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'AE',
      name: 'United Arab Emirates',
      supported: true,
      region: {
        id: 6,
        name: 'Middle East',
        supported: true,
        color: 'red',
      },
    },
  },
  {
    id: 35,
    name: 'Bermuda',
    countryCode: 'BM',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'BM',
      name: 'Bermuda',
      supported: true,
      region: {
        id: 9,
        name: 'Offshore',
        supported: true,
        color: 'pink',
      },
    },
  },
  {
    id: 36,
    name: 'British Virgin Islands',
    countryCode: 'VG',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'VG',
      name: 'British Virgin Islands',
      supported: true,
      region: {
        id: 9,
        name: 'Offshore',
        supported: true,
        color: 'pink',
      },
    },
  },
  {
    id: 37,
    name: 'Cayman Islands',
    countryCode: 'KY',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'KY',
      name: 'Cayman Islands',
      supported: true,
      region: {
        id: 9,
        name: 'Offshore',
        supported: true,
        color: 'pink',
      },
    },
  },
  {
    id: 38,
    name: 'Cyprus',
    countryCode: 'CY',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'CY',
      name: 'Cyprus',
      supported: true,
      region: {
        id: 9,
        name: 'Offshore',
        supported: true,
        color: 'pink',
      },
    },
  },
  {
    id: 39,
    name: 'Guernsey',
    countryCode: 'GG',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'GG',
      name: 'Guernsey',
      supported: true,
      region: {
        id: 9,
        name: 'Offshore',
        supported: true,
        color: 'pink',
      },
    },
  },
  {
    id: 40,
    name: 'Isle of Man',
    countryCode: 'IM',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'IM',
      name: 'Isle of Man',
      supported: true,
      region: {
        id: 9,
        name: 'Offshore',
        supported: true,
        color: 'pink',
      },
    },
  },
  {
    id: 41,
    name: 'Jersey',
    countryCode: 'JE',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'JE',
      name: 'Jersey',
      supported: true,
      region: {
        id: 9,
        name: 'Offshore',
        supported: true,
        color: 'pink',
      },
    },
  },
  {
    id: 42,
    name: 'Malta',
    countryCode: 'MT',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'MT',
      name: 'Malta',
      supported: true,
      region: {
        id: 9,
        name: 'Offshore',
        supported: true,
        color: 'pink',
      },
    },
  },
  {
    id: 43,
    name: 'Mauritius',
    countryCode: 'MU',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'MU',
      name: 'Mauritius',
      supported: true,
      region: {
        id: 9,
        name: 'Offshore',
        supported: true,
        color: 'pink',
      },
    },
  },
  {
    id: 44,
    name: 'Seychelles',
    countryCode: 'SC',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'SC',
      name: 'Seychelles',
      supported: true,
      region: {
        id: 9,
        name: 'Offshore',
        supported: true,
        color: 'pink',
      },
    },
  },
  {
    id: 45,
    name: 'Canada',
    countryCode: 'CA',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'CA',
      name: 'Canada',
      supported: true,
      region: {
        id: 7,
        name: 'North America',
        supported: true,
        color: 'green',
      },
    },
  },
  {
    id: 46,
    name: 'United States',
    countryCode: 'US',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'US',
      name: 'United States',
      supported: true,
      region: {
        id: 7,
        name: 'North America',
        supported: true,
        color: 'green',
      },
    },
  },
  {
    id: 47,
    name: 'Argentina',
    countryCode: 'AR',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'AR',
      name: 'Argentina',
      supported: true,
      region: {
        id: 5,
        name: 'Latin America',
        supported: true,
        color: 'yellow',
      },
    },
  },
  {
    id: 48,
    name: 'Brazil',
    countryCode: 'BR',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'BR',
      name: 'Brazil',
      supported: true,
      region: {
        id: 5,
        name: 'Latin America',
        supported: true,
        color: 'yellow',
      },
    },
  },
  {
    id: 49,
    name: 'Chile',
    countryCode: 'CL',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'CL',
      name: 'Chile',
      supported: true,
      region: {
        id: 5,
        name: 'Latin America',
        supported: true,
        color: 'yellow',
      },
    },
  },
  {
    id: 50,
    name: 'Mexico',
    countryCode: 'MX',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'MX',
      name: 'Mexico',
      supported: true,
      region: {
        id: 5,
        name: 'Latin America',
        supported: true,
        color: 'yellow',
      },
    },
  },
  {
    id: 51,
    name: 'Peru',
    countryCode: 'PE',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'PE',
      name: 'Peru',
      supported: true,
      region: {
        id: 5,
        name: 'Latin America',
        supported: true,
        color: 'yellow',
      },
    },
  },
  {
    id: 52,
    name: 'Venezuela',
    countryCode: 'VE',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'VE',
      name: 'Venezuela',
      supported: true,
      region: {
        id: 5,
        name: 'Latin America',
        supported: true,
        color: 'yellow',
      },
    },
  },
  {
    id: 53,
    name: 'Morocco',
    countryCode: 'MA',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'MA',
      name: 'Morocco',
      supported: true,
      region: {
        id: 1,
        name: 'Africa',
        supported: true,
        color: 'orange',
      },
    },
  },
  {
    id: 54,
    name: 'South Africa',
    countryCode: 'ZA',
    parentId: null,
    supported: true,
    parent: null,
    country: {
      code: 'ZA',
      name: 'South Africa',
      supported: true,
      region: {
        id: 1,
        name: 'Africa',
        supported: true,
        color: 'orange',
      },
    },
  },
  {
    id: 251,
    name: 'London',
    countryCode: 'GB',
    parentId: 1,
    supported: true,
    parent: {
      id: 1,
      name: 'United Kingdom',
      countryCode: 'GB',
      parentId: null,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 252,
    name: 'North East England',
    countryCode: 'GB',
    parentId: 1,
    supported: true,
    parent: {
      id: 1,
      name: 'United Kingdom',
      countryCode: 'GB',
      parentId: null,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 253,
    name: 'North West England',
    countryCode: 'GB',
    parentId: 1,
    supported: true,
    parent: {
      id: 1,
      name: 'United Kingdom',
      countryCode: 'GB',
      parentId: null,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 254,
    name: 'South West England',
    countryCode: 'GB',
    parentId: 1,
    supported: true,
    parent: {
      id: 1,
      name: 'United Kingdom',
      countryCode: 'GB',
      parentId: null,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 255,
    name: 'South East England',
    countryCode: 'GB',
    parentId: 1,
    supported: true,
    parent: {
      id: 1,
      name: 'United Kingdom',
      countryCode: 'GB',
      parentId: null,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 256,
    name: 'N. Ireland',
    countryCode: 'GB',
    parentId: 1,
    supported: true,
    parent: {
      id: 1,
      name: 'United Kingdom',
      countryCode: 'GB',
      parentId: null,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 257,
    name: 'Scotland',
    countryCode: 'GB',
    parentId: 1,
    supported: true,
    parent: {
      id: 1,
      name: 'United Kingdom',
      countryCode: 'GB',
      parentId: null,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 258,
    name: 'Midlands',
    countryCode: 'GB',
    parentId: 1,
    supported: true,
    parent: {
      id: 1,
      name: 'United Kingdom',
      countryCode: 'GB',
      parentId: null,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 259,
    name: 'Adelaide',
    countryCode: 'AU',
    parentId: 20,
    supported: true,
    parent: {
      id: 20,
      name: 'Australia',
      countryCode: 'AU',
      parentId: null,
      supported: true,
    },
    country: {
      code: 'AU',
      name: 'Australia',
      supported: true,
      region: {
        id: 8,
        name: 'Oceania',
        supported: true,
        color: 'grey',
      },
    },
  },
  {
    id: 260,
    name: 'Brisbane',
    countryCode: 'AU',
    parentId: 20,
    supported: true,
    parent: {
      id: 20,
      name: 'Australia',
      countryCode: 'AU',
      parentId: null,
      supported: true,
    },
    country: {
      code: 'AU',
      name: 'Australia',
      supported: true,
      region: {
        id: 8,
        name: 'Oceania',
        supported: true,
        color: 'grey',
      },
    },
  },
  {
    id: 261,
    name: 'Melbourne',
    countryCode: 'AU',
    parentId: 20,
    supported: true,
    parent: {
      id: 20,
      name: 'Australia',
      countryCode: 'AU',
      parentId: null,
      supported: true,
    },
    country: {
      code: 'AU',
      name: 'Australia',
      supported: true,
      region: {
        id: 8,
        name: 'Oceania',
        supported: true,
        color: 'grey',
      },
    },
  },
  {
    id: 262,
    name: 'Perth',
    countryCode: 'AU',
    parentId: 20,
    supported: true,
    parent: {
      id: 20,
      name: 'Australia',
      countryCode: 'AU',
      parentId: null,
      supported: true,
    },
    country: {
      code: 'AU',
      name: 'Australia',
      supported: true,
      region: {
        id: 8,
        name: 'Oceania',
        supported: true,
        color: 'grey',
      },
    },
  },
  {
    id: 263,
    name: 'Sydney',
    countryCode: 'AU',
    parentId: 20,
    supported: true,
    parent: {
      id: 20,
      name: 'Australia',
      countryCode: 'AU',
      parentId: null,
      supported: true,
    },
    country: {
      code: 'AU',
      name: 'Australia',
      supported: true,
      region: {
        id: 8,
        name: 'Oceania',
        supported: true,
        color: 'grey',
      },
    },
  },
  {
    id: 264,
    name: 'Auckland',
    countryCode: 'NZ',
    parentId: 21,
    supported: true,
    parent: {
      id: 21,
      name: 'New Zealand',
      countryCode: 'NZ',
      parentId: null,
      supported: true,
    },
    country: {
      code: 'NZ',
      name: 'New Zealand',
      supported: true,
      region: {
        id: 8,
        name: 'Oceania',
        supported: true,
        color: 'grey',
      },
    },
  },
  {
    id: 265,
    name: 'Christchurch',
    countryCode: 'NZ',
    parentId: 21,
    supported: true,
    parent: {
      id: 21,
      name: 'New Zealand',
      countryCode: 'NZ',
      parentId: null,
      supported: true,
    },
    country: {
      code: 'NZ',
      name: 'New Zealand',
      supported: true,
      region: {
        id: 8,
        name: 'Oceania',
        supported: true,
        color: 'grey',
      },
    },
  },
  {
    id: 266,
    name: 'Wellington',
    countryCode: 'NZ',
    parentId: 21,
    supported: true,
    parent: {
      id: 21,
      name: 'New Zealand',
      countryCode: 'NZ',
      parentId: null,
      supported: true,
    },
    country: {
      code: 'NZ',
      name: 'New Zealand',
      supported: true,
      region: {
        id: 8,
        name: 'Oceania',
        supported: true,
        color: 'grey',
      },
    },
  },
  {
    id: 267,
    name: 'Newcastle',
    countryCode: 'GB',
    parentId: 252,
    supported: true,
    parent: {
      id: 252,
      name: 'North East England',
      countryCode: 'GB',
      parentId: 1,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 268,
    name: 'Sheffield',
    countryCode: 'GB',
    parentId: 252,
    supported: true,
    parent: {
      id: 252,
      name: 'North East England',
      countryCode: 'GB',
      parentId: 1,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 269,
    name: 'Leeds',
    countryCode: 'GB',
    parentId: 253,
    supported: true,
    parent: {
      id: 253,
      name: 'North West England',
      countryCode: 'GB',
      parentId: 1,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 270,
    name: 'Liverpool',
    countryCode: 'GB',
    parentId: 253,
    supported: true,
    parent: {
      id: 253,
      name: 'North West England',
      countryCode: 'GB',
      parentId: 1,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 271,
    name: 'Manchester',
    countryCode: 'GB',
    parentId: 253,
    supported: true,
    parent: {
      id: 253,
      name: 'North West England',
      countryCode: 'GB',
      parentId: 1,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 272,
    name: 'Bristol',
    countryCode: 'GB',
    parentId: 254,
    supported: true,
    parent: {
      id: 254,
      name: 'South West England',
      countryCode: 'GB',
      parentId: 1,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 273,
    name: 'Exeter',
    countryCode: 'GB',
    parentId: 254,
    supported: true,
    parent: {
      id: 254,
      name: 'South West England',
      countryCode: 'GB',
      parentId: 1,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 274,
    name: 'Wales',
    countryCode: 'GB',
    parentId: 254,
    supported: true,
    parent: {
      id: 254,
      name: 'South West England',
      countryCode: 'GB',
      parentId: 1,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 275,
    name: 'Cambridge',
    countryCode: 'GB',
    parentId: 255,
    supported: true,
    parent: {
      id: 255,
      name: 'South East England',
      countryCode: 'GB',
      parentId: 1,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 276,
    name: 'Milton Keynes',
    countryCode: 'GB',
    parentId: 255,
    supported: true,
    parent: {
      id: 255,
      name: 'South East England',
      countryCode: 'GB',
      parentId: 1,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 277,
    name: 'Oxford',
    countryCode: 'GB',
    parentId: 255,
    supported: true,
    parent: {
      id: 255,
      name: 'South East England',
      countryCode: 'GB',
      parentId: 1,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 278,
    name: 'Portsmouth',
    countryCode: 'GB',
    parentId: 255,
    supported: true,
    parent: {
      id: 255,
      name: 'South East England',
      countryCode: 'GB',
      parentId: 1,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 279,
    name: 'Reading',
    countryCode: 'GB',
    parentId: 255,
    supported: true,
    parent: {
      id: 255,
      name: 'South East England',
      countryCode: 'GB',
      parentId: 1,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 280,
    name: 'Southampton',
    countryCode: 'GB',
    parentId: 255,
    supported: true,
    parent: {
      id: 255,
      name: 'South East England',
      countryCode: 'GB',
      parentId: 1,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 281,
    name: 'Winchester',
    countryCode: 'GB',
    parentId: 255,
    supported: true,
    parent: {
      id: 255,
      name: 'South East England',
      countryCode: 'GB',
      parentId: 1,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 282,
    name: 'Belfast',
    countryCode: 'GB',
    parentId: 256,
    supported: true,
    parent: {
      id: 256,
      name: 'N. Ireland',
      countryCode: 'GB',
      parentId: 1,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 283,
    name: 'Aberdeen',
    countryCode: 'GB',
    parentId: 257,
    supported: true,
    parent: {
      id: 257,
      name: 'Scotland',
      countryCode: 'GB',
      parentId: 1,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 284,
    name: 'Edinburgh',
    countryCode: 'GB',
    parentId: 257,
    supported: true,
    parent: {
      id: 257,
      name: 'Scotland',
      countryCode: 'GB',
      parentId: 1,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 285,
    name: 'Glasgow',
    countryCode: 'GB',
    parentId: 257,
    supported: true,
    parent: {
      id: 257,
      name: 'Scotland',
      countryCode: 'GB',
      parentId: 1,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 286,
    name: 'Birmingham',
    countryCode: 'GB',
    parentId: 258,
    supported: true,
    parent: {
      id: 258,
      name: 'Midlands',
      countryCode: 'GB',
      parentId: 1,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 287,
    name: 'Coventry',
    countryCode: 'GB',
    parentId: 258,
    supported: true,
    parent: {
      id: 258,
      name: 'Midlands',
      countryCode: 'GB',
      parentId: 1,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 288,
    name: 'Leicester',
    countryCode: 'GB',
    parentId: 258,
    supported: true,
    parent: {
      id: 258,
      name: 'Midlands',
      countryCode: 'GB',
      parentId: 1,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
  {
    id: 289,
    name: 'Nottingham',
    countryCode: 'GB',
    parentId: 258,
    supported: true,
    parent: {
      id: 258,
      name: 'Midlands',
      countryCode: 'GB',
      parentId: 1,
      supported: true,
    },
    country: {
      code: 'GB',
      name: 'United Kingdom',
      supported: true,
      region: {
        id: 4,
        name: 'Europe',
        supported: true,
        color: 'magenta',
      },
    },
  },
]

export const getLocation = locationName => {
  if (!locationName)
    return {
      code: 'GB',
      name: 'Unknown',
      region: {id: 4, name: 'Europe', supported: true, color: 'magenta'},
    }
  const location = locationsList.find(
    location => location.name === locationName
  )
  if (!location) {
    console.error(`could not get location for ${locationName}`)
  }
  return location
}

export const getLocationColor = location => {
  if (!location) return ''
  try {
    const countryCode = location.countryCode
    if (countryCode === 'GB') {
      return 'london'
    }

    return location.country.region.color
  } catch (error) {
    console.error('getCountryFromLocationName', error)
    return 'london'
  }
}

export const getLocationFlag = location => {
  // console.debug('getLocationFlag', location)
  if (!location) return ''
  return getFlagEmoji(location.countryCode)
}

export const getLocationColorAndFlag = locationName => {
  // console.debug('getLocationColorAndFlag', locationName)
  const location = getLocation(locationName)
  if (!location) return {color: '', flag: ''}
  return {
    color: getLocationColor(location),
    flag: getLocationFlag(location),
  }
}



// WEBPACK FOOTER //
// ./scripts/shared/location-flag-and-color.js